import React from 'react';

import { Tooltip, Typography } from '@mui/material';

interface Props {
  name: string | null;
  id: string | null;
  /** Shown instead of the name when the id itself is absent (not just unnamed). */
  emptyLabel?: string;
}

// Name with the UUID in a tooltip. An id that resolves to no name is flagged:
// it means the record was deleted, or a provider code matches nothing.
export default function NamedId({ name, id, emptyLabel = '—' }: Props) {
  if (!id) {
    return <>{emptyLabel}</>;
  }

  if (!name) {
    return (
      <Tooltip title={`${id} — no matching record in svc-reservation`}>
        <Typography
          variant="body2"
          component="span"
          color="warning.main"
          sx={{ fontFamily: 'ui-monospace, Menlo, monospace' }}
        >
          {id.slice(0, 8)}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={id}>
      <Typography variant="body2" component="span">
        {name}
      </Typography>
    </Tooltip>
  );
}
